<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>

    <br />

    <buttonc
      label="Sync All"
      type="block"
      :classes="getClassForBtn('all')"
      @click="onSyncAllBtnClick()"
    />

    <hr />

    <buttonc
      label="Sync Company Groups"
      :classes="getClassForBtn('companyGroups')"
      @click="onSyncBtnClick('companyGroups')"
    />
    <buttonc
      label="Sync Companies"
      :classes="getClassForBtn('companies')"
      @click="onSyncBtnClick('companies')"
    />
    <buttonc
      label="Sync Stores"
      :classes="getClassForBtn('stores')"
      @click="onSyncBtnClick('stores')"
    />
    <buttonc
      label="Sync Players"
      :classes="getClassForBtn('players')"
      @click="onSyncBtnClick('players')"
    />

    <hr />

    <ul class="log-list">
      <li v-for="log of logs.data" :key="log.id">
        <div class="text-monospace">
          <b>{{ log.startedAt | formatDate }}</b> ({{ getSeconds(log) }}s)
          <i
            v-if="!log.error"
            class="fa fa-check-circle"
            style="color: var(--success)"
          ></i>
          <i v-else class="fa fa-times-circle" style="color: var(--danger)"></i>
        </div>
        <div class="log-indent">
          Tabelle: <b>{{ log.targetTable }}</b
          >, gestartet von <b>{{ log.triggeredBy }}</b
          >&nbsp;
          <b>({{ log.triggerType }})</b>
        </div>
        <p class="log-indent" v-if="log.error">
          <span style="color: var(--danger)">Fehler:</span>
          {{ log.error }}
        </p>
      </li>
    </ul>
    <div class="pagination">
      <buttonc
        icon="fa-chevron-left"
        :disabled="!logs.prev_page_url"
        @click="prevPage()"
      />
      <span
        style="background-color: var(--contrast-1); color: var(--contrast-4)"
      >
        {{ logs.current_page }}
      </span>
      <buttonc
        icon="fa-chevron-right"
        :disabled="!logs.next_page_url"
        @click="nextPage()"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import buttonc from "../uicomponents/button.vue";
import moment from "moment/moment";

export default {
  components: { buttonc },
  name: "sync",
  data() {
    return {
      logs: [],
      btnState: {},
    };
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    if (
      this.$store.state.jwt != undefined &&
      this.$store.state.companyId != undefined
    ) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters(["companyId", "isSuperUser"]),

    headerButtons() {
      let view = this;
      let state = { buttons: [] };
      /*
      state.buttons.push({ type: "block", icon: "fa-eye", click: () => { }, tooltip: 'VIEW' });
      state.buttons.push({ type: "block", icon: "fa-cloud-download-alt", click: () => { view.loadExternalUsersFromKundencenter(); }, tooltip: 'SYNC' });
      */
      return state;
    },
  },
  // methods that implement data logic.
  methods: {
    async refresh(force = false) {
      const res = await this.axios.get("/api/sec/sync/logs", {
        headers: { Authorization: "Bearer " + this.$store.state.jwt },
      });
      this.logs = res.data;
    },
    async sync(table) {
      try {
        const response = await this.axios.post("/api/sec/sync", null, {
          params: { table },
          headers: { Authorization: "Bearer " + this.$store.state.jwt },
        });
        // if (response.status === 202) alert('sync success');
        // else alert('error');
        return response.status === 202;
      } catch {
        return false;
      }
    },
    async syncAll() {
      return (
        (await this.sync("companyGroups")) &&
        (await this.sync("companies")) &&
        (await this.sync("stores")) &&
        (await this.sync("players"))
      );
    },
    async onSyncAllBtnClick() {
      const success = await this.syncAll();
      this.$set(this.btnState, "all", success);
      // reset button state
      setTimeout(() => this.$set(this.btnState, "all", null), 3000);
      await this.refresh();
    },
    async onSyncBtnClick(table) {
      const success = await this.sync(table);
      this.$set(this.btnState, table, success);
      // reset button state
      setTimeout(() => this.$set(this.btnState, table, null), 3000);
      await this.refresh();
    },
    getClassForBtn(button) {
      const btnState = this.btnState[button];
      return btnState === true ? "green" : btnState === false ? "red" : "";
    },
    getSeconds(log) {
      const startedAt = moment(String(log.startedAt));
      const finishedAt = moment(String(log.finishedAt));
      return finishedAt.subtract(startedAt).format("ss.SS");
    },
    async prevPage() {
      if (!this.logs.prev_page_url) return;
      const res = await this.axios.get(this.logs.prev_page_url, {
        headers: { Authorization: "Bearer " + this.$store.state.jwt },
      });
      this.logs = res.data;
    },
    async nextPage() {
      if (!this.logs.next_page_url) return;
      const res = await this.axios.get(this.logs.next_page_url, {
        headers: { Authorization: "Bearer " + this.$store.state.jwt },
      });
      this.logs = res.data;
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY HH:mm:ss");
      }
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.xColumn3 {
  width: 400px;
  text-align: left;
  float: left;
  margin-left: 25px;
  margin-right: 25px;
  overflow-y: auto;
  max-height: 800px;
}

.log-list {
  list-style: none;
  text-align: left;
}

.log-indent {
  margin-left: 2rem;
}

.pagination {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.pagination > * {
  min-width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
